import React from "react";
import PropTypes from "prop-types";
import { recordIdType } from "data/util/typedefs";
import SelectionTable from "../../../common/selectiontable/SelectionTable";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";

function RecordSourceInstanceGrid(props) {
    const {
        results,
        onSelectModel,
        resultLabeler,
        maxHeight,
        hasPagination,
        pagination,
        onPage,
        isLoading = false
    } = props;
    const items = results.map(ep => ({
        ep,
        id: ep.id,
        data: {
            label: resultLabeler
                ? resultLabeler(ep)
                : ep.getLabel(),
        },
    }));
    const indexZeroPage = pagination.page - 1;
    return <div className="search-results-container">
        {isLoading && <div className="local-over-modal"><img src="images/waiting.svg" alt="Loading..." /></div>}
        <SelectionTable
            records={items}
            fixedHeaders
            columns={[
                {
                    key: "label",
                    name: "Results",
                    type: "string",
                },
            ]}
            onRecordSelection={it => onSelectModel(it.ep)}
            maxHeight={maxHeight}
        />
        {
            (
                hasPagination && (items.length >= pagination.pageSize ||
                pagination.page > 1)) && (
                <div className="row search-pagination">
                    <div className="col-sm-6">
                        <div className="search-pagination-summary">
                            Showing results {indexZeroPage * pagination.pageSize + 1} to {indexZeroPage * pagination.pageSize + items.length}
                        </div>
                    </div>
                    <div className="col-sm-6 text-right">
                        <div className="search-pagination-buttons">
                            <Button
                                enabled={pagination.page > 1}
                                onClick={() => onPage(pagination.page - 1)}
                                label={"<"}
                            />
                            <strong> Page {pagination.page} </strong>
                            <Button
                                enabled={items.length >= pagination.pageSize}
                                onClick={() => onPage(pagination.page + 1)}
                                label={">"}
                            />
                        </div>
                    </div>
                </div>
            )
        }
    </div>;

}

RecordSourceInstanceGrid.propTypes = {
    results: PropTypes.arrayOf(PropTypes.shape({
        id: recordIdType.isRequired,
        getLabel: PropTypes.func.isRequired,
    })).isRequired,
    pagination: PropTypes.shape({
        page: PropTypes.number,
        pageSize: PropTypes.number,
        totalResultCount: PropTypes.number,
    }),
    onSelectModel: PropTypes.func.isRequired,
    resultLabeler: PropTypes.func,
    maxHeight: PropTypes.string,
    onPage: PropTypes.func,
    hasPagination: PropTypes.bool,
    isLoading: PropTypes.bool,
};

export default RecordSourceInstanceGrid;



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourceinstancegrid/RecordSourceInstanceGrid.js